module.exports = __webpack_public_path__ + "img/erp_edeungan_logo_400px.410b5f62.png";